module.exports = __webpack_public_path__ + "img/1280.b22f316d.svg";